export var VideoTrackKind = {
    alternative: 'alternative',
    captions: 'captions',
    main: 'main',
    sign: 'sign',
    subtitles: 'subtitles',
    commentary: 'commentary'
};
export var AudioTrackKind = {
    alternative: 'alternative',
    descriptions: 'descriptions',
    main: 'main',
    'main-desc': 'main-desc',
    translation: 'translation',
    commentary: 'commentary'
};
export var TextTrackKind = {
    subtitles: 'subtitles',
    captions: 'captions',
    descriptions: 'descriptions',
    chapters: 'chapters',
    metadata: 'metadata'
};
export var TextTrackMode = {
    disabled: 'disabled',
    hidden: 'hidden',
    showing: 'showing'
};